import RichUpdatesItem from './RichUpdatesItem';

export default RichUpdatesItem;
